import Subject from './Subject'

export default Subject
